<template>
  <v-alert type="warning" prominent border="left" icon="mdi-alert" class="ma-2 mb-4 text-start">
    <v-row align="center">
      <v-col class="grow">
        <strong>This page is deprecated.</strong>
        Please use the new Engraving Dashboard app in Shopify instead. This page is no longer
        maintained and may stop working at any time.
      </v-col>
      <v-col class="shrink">
        <v-btn
          color="white"
          light
          href="https://admin.shopify.com/store/mizodia-jewelry/apps/engraving-dashboard/app"
          target="_blank"
        >
          Open new app
          <v-icon right small>mdi-open-in-new</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
  export default {
    name: 'DeprecationBanner',
  }
</script>
